import React from 'react';
import Dither from '@/components/landing/common/Dither';
import { Link } from 'react-router-dom';
import styled  from 'styled-components';
import {ChevronRight} from 'lucide-react'
import { breakpoints } from '@/layouts/breakpoints'


const StyledComp = styled.div`

  .cta-section {
    position: relative;
    padding: 120px 40px;
    overflow: hidden;

    .cta-background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      &:before{
        position: absolute;
        z-index: 2;
        content: '';
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: white;
        pointer-events: none;
        opacity: 0.9;

      }
    }


    h2 {
      position: relative;
      z-index: 2;
      margin: 0 auto;
      margin-bottom: 24px;
      line-height: 1.2;
      text-align: center;
    }

    p {
      position: relative;
      z-index: 2;
      font-size: 16px;
      line-height: 1.8;
      color: var(--grey);
      margin-bottom: 48px;
      text-align: center;
      max-width: 800px;
      margin-left: auto;
      margin-right: auto;
    }

    .cta-buttons, .cta-actions {
      position: relative;
      z-index: 2;
      display: flex;
      flex-direction: row;
      justify-content: center;
      gap: 16px;
      pointer-events: all;

      button, a {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 10px 24px;
        border-radius: 8px;
        font-size: 16px;
        cursor: pointer;
        text-decoration: none;
        transition: all 0.3s;

        &.primary {
          background-color: var(--black);
          color: var(--white);
          border: 1px solid var(--black);

          &:hover {
            background-color: #333;
          }
        }

        &.secondary {
          background-color: transparent;
          color: var(--black);
          svg {
            transition-duration: 0.3s;
          }
          &:hover {
            background-color: #eee;
            svg {
              transform: translateX(2px);
            }
          }
        }
      }
    }

    .cta-content {
      position: relative;
      z-index: 2;
      max-width: 900px;
      margin: 0 auto;
      pointer-events: none;
      text-align: center;

     small {
        font-size: 12px;
        color: var(--grey);

      }
      h2 {
        font-size: 56px;
        margin-bottom: 24px;
        line-height: 1.2;
        @media (max-width: ${breakpoints.medium}) {
          font-size: 48px;
          width: 100%;
        }
        @media (max-width: ${breakpoints.small}) {
          font-size: 40px;
        }
      }

      p {
        font-size: 16px;
        line-height: 1.8;
        color: var(--grey);
        margin-bottom: 48px;
        @media (max-width: ${breakpoints.small}) {
          font-size: 14px;
        }
      }

      .cta-actions {
        display: flex;
        flex-direction: row;
        justify-content: center;
        gap: 16px;
        margin-bottom: 36px;

        @media (max-width: ${breakpoints.medium}) {
          flex-direction: column;
            button{
              text-align: center;
              justify-content: center;
            }
        }

        button, a {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 10px 24px;
          border-radius: 8px;
          font-size: 16px;
          cursor: pointer;
          text-decoration: none;
          transition: all 0.3s;

          &.primary {
            background-color: var(--black);
            color: var(--white);
            border: 1px solid var(--black);

            &:hover {
              background-color: #333;
            }
          }

          &.secondary {
            background-color: transparent;
            color: var(--black);
            svg {
              transition-duration: 0.3s;
            }
            &:hover {
              background-color: #eee;
              svg {
                transform: translateX(2px);
              }
            }
          }
        }
      }
    }
  }
`;

const shapes = ['square', 'circle', 'triangle', 'diamond']
const colors = ["#55efc4", "#00b894", "#81ecec", "#00cec9", "#74b9ff", "#0984e3", "#a29bfe", "#6c5ce7", "#fdcb6e", "#e17055", "#d63031", "#e84393", "#fd79a8", "#ff7675"]
const rand = <T,>(arr: T[]) => arr[Math.floor(Math.random() * arr.length)];

const Comp = ({
  title="Start Building with the AxionQuant Financial Data API",
  text="Join thousands of developers and quants using AxionQuant to power financial applications with market data, fundamentals, and alternative data. Grab your free API key and start pulling stock market data in minutes.",
  primary={
    title: "Get API Key",
      url: "/login"
  },
  secondary={
    title: "Read docs",
    url: "/docs"
  }
}) => {

  return (
    <StyledComp>
      <div className="cta-section">
        <div className="cta-background">
          <Dither
            shape={rand(shapes)}
            inkColor={rand(colors)}
            backgroundColor="#fff"
            pixelSize={Math.floor(Math.random() * 7) + 4} // 2-10
          />
      </div>
      <div className="cta-content">
        <h2 className="serif">{title}</h2>
        <p> {text} </p>
        <div className="cta-actions">
          <Link to={primary.url} className="primary">
            {primary.title}
          </Link>

          <Link to={secondary.url} className="secondary">
              {secondary.title} <ChevronRight />
          </Link>
        </div>
        <small> No credit card required • free tier is free forever </small>
      </div>

    </div>

    </StyledComp>
  );
};

export default Comp;
